export const MENTION_SUGGESTION_LIST_CLASS_NAME = 'mention-suggestion-list'
